// third-party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import axios from "utils/axios";
import { dispatch } from "../index";

// initial state
interface productsState {
  error: Error | null;
  list: Product[];
  my: My;
}

const initialState: productsState = {
  error: null,
  list: [],
  my: {
    coin: 0,
    first_pay: false
  }
};

// ==============================|| SLICE - MENU ||============================== //

const products = createSlice({
  name: "products",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    getListSuccess(state, action) {
      state.list = action.payload.product_list;
    },

    getMySuccess(state, action) {
      state.my = action.payload;
    }
  }
});

export default products.reducer;

// Actions
export const { getListSuccess } = products.actions;

export function getList(cate: string) {
  return async () => {
    try {
      const response = await axios.post(`base/products`, { cate });

      if (response.data.code === 0) {
        dispatch(products.actions.getListSuccess(response.data.data));
      } else {
        dispatch(products.actions.getListSuccess([]));
      }
    } catch (error) {
      dispatch(products.actions.getListSuccess([]));
      dispatch(products.actions.hasError(error));
    }
  };
}

export function getMy() {
  return async () => {
    try {
      const response = await axios.post(`base/myCoin`);

      if (response.data.code === 0) {
        dispatch(products.actions.getMySuccess(response.data.data));
      } else {
        dispatch(products.actions.getMySuccess(null));
      }
    } catch (error) {
      dispatch(products.actions.getMySuccess(null));
      dispatch(products.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export interface Product {
  coin: number;
  discount: number;
  price: number;
  group_id: string;
  sku_id: string;
  product_id: string;
  name: string;
  desc: string;
  currency: string;
  pay_type: number;
  gold: number;
  icon: string;
  max_quantity: number; // 最大购买次数
  quantity: number; // 限购次数
  rewards: Reward[];
}

export interface Reward {
  amount: number;
  internal_id: number;
  desc: string;
  image: string;
  image_chip: string;
  image_quality: string;
  item_id: string;
  name: string;
}

export enum ProductCate {
  BUILDING = "building",
  GEM = "gemstone",
  STONE = "dragon_stone", //龙语石头
  ARTIFACTS = "parliament_hero_artifact", //神器
  EQUIP = "equipment", // 装备
  UNITS = "other", // 加速
  EMBLEM = "emblem" //印记
}

export interface My {
  coin: number;
  first_pay: boolean;
}
